var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "form-block"
  }, [_c("div", {
    staticClass: "source"
  }, [_c("el-form", {
    ref: "formData",
    staticClass: "demo-form",
    attrs: {
      model: _vm.formData,
      rules: _vm.rules,
      "label-position": "left"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "Enabled",
      prop: "enabled"
    }
  }, [_c("el-switch", {
    model: {
      value: _vm.formData.enabled,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "enabled", $$v);
      },
      expression: "formData.enabled"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Is Primary",
      prop: "isPrimary"
    }
  }, [_c("el-switch", {
    model: {
      value: _vm.formData.isPrimary,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "isPrimary", $$v);
      },
      expression: "formData.isPrimary"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Full Name",
      prop: "fullName"
    }
  }, [_c("el-input", {
    attrs: {
      name: "fullName",
      required: "",
      placeholder: "Full Name"
    },
    model: {
      value: _vm.formData.fullName,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "fullName", $$v);
      },
      expression: "formData.fullName"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Alias",
      prop: "alias"
    }
  }, [_c("el-input", {
    attrs: {
      name: "alias"
    },
    model: {
      value: _vm.formData.alias,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "alias", $$v);
      },
      expression: "formData.alias"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Email",
      prop: "emailAddress"
    }
  }, [_c("el-input", {
    attrs: {
      name: "emailAddress",
      placeholder: "Email"
    },
    model: {
      value: _vm.formData.emailAddress,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "emailAddress", $$v);
      },
      expression: "formData.emailAddress"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Mobile Number",
      prop: "mobileNumber"
    }
  }, [_c("el-input", {
    attrs: {
      name: "mobileNumber",
      placeholder: "Mobile Number"
    },
    model: {
      value: _vm.formData.mobileNumber,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "mobileNumber", $$v);
      },
      expression: "formData.mobileNumber"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Forced Logout",
      prop: "forcedLogout"
    }
  }, [_c("el-switch", {
    model: {
      value: _vm.formData.forcedLogout,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "forcedLogout", $$v);
      },
      expression: "formData.forcedLogout"
    }
  })], 1), _vm.canChangePassword() ? _c("el-form-item", {
    attrs: {
      label: "Change Password",
      prop: "changePassword"
    }
  }, [_c("el-switch", {
    on: {
      change: _vm.resetPassword
    },
    model: {
      value: _vm.changePassword,
      callback: function ($$v) {
        _vm.changePassword = $$v;
      },
      expression: "changePassword"
    }
  })], 1) : _vm._e(), _vm.changePassword || !_vm.isEdit ? _c("el-form-item", {
    attrs: {
      label: "Password",
      prop: "password"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "Password",
      "show-password": "",
      name: "password"
    },
    model: {
      value: _vm.formData.password,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "password", $$v);
      },
      expression: "formData.password"
    }
  })], 1) : _vm._e(), _c("el-form-item", {
    attrs: {
      label: "Role",
      required: ""
    }
  }, [_c("el-select", {
    attrs: {
      filterable: "",
      multiple: "",
      placeholder: "Select"
    },
    on: {
      change: _vm.handleRoleChange
    },
    model: {
      value: _vm.selectedRoles,
      callback: function ($$v) {
        _vm.selectedRoles = $$v;
      },
      expression: "selectedRoles"
    }
  }, _vm._l(_vm.roleList, function (role) {
    return _c("el-option", {
      key: role.id,
      attrs: {
        label: role.name,
        value: role.id,
        disabled: _vm.isRoleDisabled(role.id)
      }
    });
  }), 1)], 1), _vm.isSalesExecutiveSelected() || _vm.isZonalManagerSelected() ? _c("el-form-item", {
    attrs: {
      label: "Dealers"
    }
  }, [_c("el-select", {
    attrs: {
      filterable: "",
      multiple: "",
      "collapse-tags": true,
      placeholder: "Select Dealers",
      "loading-text": "Loading dealer options...",
      loading: _vm.dealersLoading
    },
    model: {
      value: _vm.selectedDealers,
      callback: function ($$v) {
        _vm.selectedDealers = $$v;
      },
      expression: "selectedDealers"
    }
  }, _vm._l(_vm.dealerOptions, function (dealer) {
    return _c("el-option", {
      key: dealer.id,
      attrs: {
        label: `${dealer.name}`,
        value: dealer.id,
        disabled: dealer.isAlreadyAssigned
      }
    });
  }), 1), _c("el-button", {
    attrs: {
      type: "text",
      icon: "el-icon-setting"
    },
    on: {
      click: _vm.showDealerFilterModal
    }
  }, [_vm._v(" Filter Dealers ")])], 1) : _vm._e(), _c("el-form-item", [_c("el-button", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }, {
      name: "waves",
      rawName: "v-waves"
    }],
    attrs: {
      type: "success"
    },
    on: {
      click: _vm.submitForm
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("global.form.save")) + " ")]), _c("el-button", {
    directives: [{
      name: "waves",
      rawName: "v-waves"
    }],
    attrs: {
      type: "reset"
    },
    on: {
      click: _vm.resetForm
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("global.form.reset")) + " ")])], 1)], 1), _c("el-dialog", {
    attrs: {
      title: "Filter Dealers",
      visible: _vm.showDealerFilter,
      width: "50%"
    },
    on: {
      "update:visible": function ($event) {
        _vm.showDealerFilter = $event;
      }
    }
  }, [_c("el-form", [_c("el-form-item", {
    attrs: {
      label: "State"
    }
  }, [_c("el-select", {
    attrs: {
      filterable: "",
      multiple: "",
      placeholder: "Select States",
      clearable: ""
    },
    model: {
      value: _vm.selectedStates,
      callback: function ($$v) {
        _vm.selectedStates = $$v;
      },
      expression: "selectedStates"
    }
  }, _vm._l(_vm.states, function (state) {
    return _c("el-option", {
      key: state.id,
      attrs: {
        label: state.name,
        value: state.id
      }
    });
  }), 1)], 1), _c("el-form-item", {
    attrs: {
      label: "Branch"
    }
  }, [_c("el-select", {
    attrs: {
      filterable: "",
      multiple: "",
      placeholder: "Select Branches",
      clearable: ""
    },
    model: {
      value: _vm.selectedBranches,
      callback: function ($$v) {
        _vm.selectedBranches = $$v;
      },
      expression: "selectedBranches"
    }
  }, _vm._l(_vm.branches, function (branch) {
    return _c("el-option", {
      key: branch.id,
      attrs: {
        label: branch.code,
        value: branch.id
      }
    });
  }), 1)], 1), _c("el-form-item", {
    attrs: {
      label: "Agent"
    }
  }, [_c("el-select", {
    attrs: {
      filterable: "",
      multiple: "",
      placeholder: "Select Agents",
      clearable: ""
    },
    model: {
      value: _vm.selectedAgents,
      callback: function ($$v) {
        _vm.selectedAgents = $$v;
      },
      expression: "selectedAgents"
    }
  }, _vm._l(_vm.agents, function (agent) {
    return _c("el-option", {
      key: agent.id,
      attrs: {
        label: agent.name,
        value: agent.id
      }
    });
  }), 1)], 1)], 1), _c("span", {
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    on: {
      click: _vm.cancelDealerFilters
    }
  }, [_vm._v("Cancel")]), _c("el-button", {
    attrs: {
      type: "primary",
      loading: _vm.filteringDealers
    },
    on: {
      click: _vm.applyDealerFilters
    }
  }, [_vm._v(" Save Choices ")])], 1)], 1)], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };